<nav class="nav-tabs">
  <a *ngFor="let tab of tabs" [ngClass]="{'disabled': disabled}" [routerLink]="tab.link" [queryParams]="tab.queryParams" class="nav-tab" routerLinkActive="active">{{tab.display}}</a>
</nav>
